import { useCallback } from 'react'

import type { IEntityAppointment } from '@user/store/scheduling'
import {
  useSchedulingWizard,
  rescheduleActionCreator as reschedule,
} from '../../../SchedulingWizard'

type Props = {
  onCloseMain: () => void
  entityAppointment: IEntityAppointment
}

export function useReschedule(props: Props) {
  const { onCloseMain, entityAppointment } = props

  const [, dispatch] = useSchedulingWizard()

  return useCallback(() => {
    dispatch(reschedule(entityAppointment))
    onCloseMain()
  }, [dispatch, entityAppointment, onCloseMain])
}
